import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Path from '@leverege/path'
import PatchOps from '@leverege/api-patch-ops'

import { MessageRouteFactory } from '../../editors/messageRoute'
import { BreadcrumbActions, MessageRouteActions } from '~/actions'

class MessageRouteScreen extends React.Component {

  constructor( props, context ) {
    super( props, context )

    const location = this.parseLocation( props.location.pathname )
    this.state = { location }

    props.dispatch( MessageRouteActions.get( location.project, location.messageRoute ) )

  }

  parseLocation( loc ) {
    const aLoc = loc.split( '/' )
    const toReturn = {}
    for ( let i = 1; i < aLoc.length; i += 2 ) {
      toReturn[aLoc[i]] = aLoc[i + 1]
    }
    return toReturn
  }

  onChange = ( { path, target, value, item } ) => {
    const { dispatch } = this.props
    const { location } = this.state
    const { messageRoute, project } = location

    if ( path === 'routes' ) {
      const oldKeys = Object.keys( item && item.routes || {} )
      const p = PatchOps()

      Object.keys( value || {} ).forEach( ( currentKey ) => {
        const oldIndex = oldKeys.indexOf( currentKey )
        if ( oldIndex === -1 ) {
          p.add( `routes/${currentKey}`, value[currentKey] )
        } else {
          p.replace( `routes/${currentKey}`, value[currentKey] )
          oldKeys.splice( oldIndex, 1 )
        }
      } )
      oldKeys.forEach( ( oldKey ) => {
        p.replace( `routes/${oldKey}`, null )
      } )
      dispatch( MessageRouteActions.update( project, messageRoute, p.ops() ) )
    } else {
      dispatch( MessageRouteActions.update( project, messageRoute, PatchOps( path, value ).ops() ) )
    }
  }

  componentDidUpdate() {
    const { location } = this.state
    const { messageRoutes } = this.props
    const toRender = Path( `lookup/${location.messageRoute}` ).get( messageRoutes, {} )

    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Message Routes', link : `/project/${location.project}/messageRoute` }, { name : toRender.name || toRender.id } ] ) )
  }

  render() {
    const { location } = this.state
    const { messageRoutes } = this.props

    const toRender = Path( `lookup/${location.messageRoute}` ).get( messageRoutes, {} )

    return (
      <div>
        {MessageRouteFactory.createEditor( toRender, { onChange : this.onChange } )}
      </div>
    )
  }
}

export default connect(
  state => ( {
    messageRoutes : state.messageRoutes
  } )
)( MessageRouteScreen )
